<template>
  <div class="steps">
    <div class="step" v-for="(step, i) in steps" :key="'step-' + i">
      <div class="step-num">{{ i + 1 }}</div>
      <div class="step-body">
        <strong>{{ step.title }}</strong>
        <p>{{ step.body }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepTimeline",
  props: {
    steps: {
      type: Array,
      required: true,
      validator: (arr) =>
        arr.every(
          (s) => typeof s.title === "string" && typeof s.body === "string"
        ),
    },
  },
};
</script>
